module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[78]443.93e66de.woff2";